import { ExpandLess, ExpandMore } from "@mui/icons-material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {
  Alert,
  Avatar,
  Breadcrumbs,
  Collapse,
  Link,
  Snackbar,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { jwtDecode } from "jwt-decode";
import PropTypes from "prop-types";
import * as React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Scrollbar } from "react-scrollbars-custom";
import suspendu from "../../assets/images/acces_suspendu.png";
import logoPortnet from "../../assets/images/Logo White PMPCE Cargo Transparent.png";
import profilImage from "../../assets/images/profil.webp";
import nonValide from "../../assets/images/souscription_non_valide.png";
import {
  resetState,
  setDrawerState,
  setIsAuthenticated,
} from "../../modules/dfd/state/DfdActions";
import { listMenus } from "../AppRoute";
import { crcInstance } from "../Axios";
import config from "../Config";
import { getRoles, hasAnyRole, roleBasedOrder } from "../utils/FunctionsUtils";
import { findIconByKey, flattenMenus } from "../utils/routeUtils";
import InstitutionalFooter from "./InstitutionalFooter";
import PopupDialogCustomized from "./PopupDialogCustomized";
import { PuiHelpWidget, PuiHelpWidgetProvider } from "@portnet/ui";

const drawerWidth = 300;

const userMenuStyles = {
  position: "absolute",
  right: 0,
  zIndex: 1,
  backgroundColor: "background.paper",
  color: "black",
  boxShadow: 3,
  borderRadius: "4px",
  overflow: "hidden",
  border: "1px solid",
  borderColor: "divider",
  padding: "4px 0",
};

const findOpenMenu = (menus, menuOpen = null) => {
  let _menus = menus.find((menu) => menu.collapse);
  console.log("findOpenMenu", menus, menuOpen, _menus);
  if (_menus) {
    menuOpen = _menus;
    if (menuOpen?.sousMenus && menuOpen?.sousMenus.length > 0) {
      findOpenMenu(menuOpen.sousMenus, menuOpen);
    }
  }
  return menuOpen;
};

const menuListStyles = {
  "&:hover": { backgroundColor: "action.hover" },
};

function DrawerMIC(props) {
  const roles = getRoles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { windowe } = props;
  const [drawerOpen, setDrawerOpen] = React.useState(true);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [menuIndex, setMenuIndex] = React.useState("");
  const [sousMenuIndex, setSousMenuIndex] = React.useState(0);
  const [menus, setMenus] = React.useState([]);
  const [openUserMenu, setOpenUserMenu] = React.useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);
  const [breadcrumb, setBreadcrumb] = React.useState("");
  const [currentPath, setCurrentPath] = React.useState("");
  const [openResetDialog, setOpenResetDialog] = React.useState(false);

  const [alertMessage, setAlertMessage] = React.useState(null);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState(null);

  const appBarStyles = {
    width: {
      xs: "100%",
      sm: drawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
    },
    ml: { sm: drawerOpen ? `${drawerWidth}px` : 0 },
    transition: "margin 0.22s ease, width 0.22s ease",
  };

  const mainContentStyles = {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    px: 0,
    pb: 0,
    pt: 9,
    ml: -3,
    boxSizing: "border-box",
    alignSelf: "stretch",
    minHeight: "100vh",
  };

  const token = localStorage.getItem("token");
  let username = "";
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      username =
        (decodedToken.firstname || "") + " " + (decodedToken.lastname || "");
    } catch (error) {
      console.error("Error decoding token", error);
    }
  }

  const getOrderedMenus = (roles, menus) => {
    const orderedMenus = [];
    const defaultOrder = menus.map((menu) => menu.name);
    const factureMenus = ["Factures", "Factures FF"];

    roles.forEach((role) => {
      const order = roleBasedOrder[role] || defaultOrder;
      const orderMenu =
        localStorage.getItem("suspend") === "true"
          ? ["Achat de Forfait", ...factureMenus]
          : localStorage.getItem("valide") === "false"
            ? ["Achat de Forfait", ...factureMenus]
            : order;

      orderMenu.forEach((menuName) => {
        const menu = menus.find((m) => m.name === menuName);
        if (menu && !orderedMenus.includes(menu) && hasAnyRole([role])) {
          orderedMenus.push(menu);
        }
      });
    });

    // menus.forEach((menu) => {
    //   if (!orderedMenus.includes(menu)) {
    //     orderedMenus.push(menu);
    //   }
    // });
    return orderedMenus;
  };

  React.useEffect(() => {
    const userRoles = getRoles();
    const orderedMenus = getOrderedMenus(userRoles, listMenus());
    setMenus(orderedMenus);
  }, [
    localStorage.getItem("token"),
    localStorage.getItem("suspend"),
    localStorage.getItem("valide"),
  ]);

  function searchInMenuByPath(menus) {
    let _menu = {};
    const currentPath = location.pathname;
    menus?.forEach((menu) => {
      console.log(
        "menu?.to?.toLowerCase()",
        menu?.to?.toLowerCase(),
        currentPath?.toLowerCase(),
        menu?.to?.toLowerCase() === currentPath?.toLowerCase()
      );
      if ("/" + menu?.to?.toLowerCase() === currentPath?.toLowerCase()) {
        _menu = menu;
        return;
      }
    });
    return _menu;
  }

  React.useEffect(() => {
    const currentPath = location.pathname;
    let foundMenu = searchInMenuByPath(flattenMenus(listMenus()));
    console.log("foundMenuIndex", foundMenu);
    if (Object.keys(foundMenu).length > 0 && foundMenu?.key !== undefined) {
      setMenuIndex(foundMenu.key);
      setBreadcrumb(
        <Breadcrumbs
          aria-label="breadcrumb"
          separator=">"
          sx={{
            "& .MuiBreadcrumbs-separator": {
              color: "white",
            },
          }}
        >
          {foundMenu?.name !== "Tableau de bord" && (
            <Link
              underline="hover"
              color="inherit"
              onClick={() => {
                if (currentPath !== "/home") {
                  setCurrentPath("/home");
                  navigate("/home");
                }
              }}
              sx={{ cursor: "pointer", color: "white" }}
            >
              Tableau de bord
            </Link>
          )}
          <Link underline="none" color="inherit" sx={{ color: "white" }}>
            {foundMenu?.drawerName}
          </Link>
        </Breadcrumbs>
      );
    }
  }, [location, menus]);

  const handlePasswordChange = () => {
    setMenuIndex(
      menus.findIndex(
        (menu, index) => menu?.to?.toLowerCase() === "/changementmdp"
      )
    );
    setOpenUserMenu(false);
    navigate(`/changementmdp`);
  };

  const handleResetClick = () => {
    setOpenResetDialog(true);
  };

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenLogoutDialog(false);
    setOpenResetDialog(false);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("suspend");
    localStorage.removeItem("valide");
    dispatch(setIsAuthenticated(false));
    dispatch(resetState());
    setOpenLogoutDialog(false);
    navigate("/");
  };

  const handleConfirmReset = async () => {
    try {
      let token = localStorage.getItem("token");

      if (!token) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        token = localStorage.getItem("token");
      }
      const response = await crcInstance.delete("/api/user/resetMFA", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setAlertMessage(response?.data);
      handleCloseDialog();
      setAlertOpen(true);
      setSeverity("success");
    } catch (error) {
      setAlertMessage(error?.response?.data);
      setAlertOpen(true);
      setSeverity("error");
    }
  };

  const handleSnackClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }

    setTimeout(() => { }, 2500);

    setAlertOpen(false);
  };

  const handleUserIconClick = () => {
    setOpenUserMenu((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpenUserMenu(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
    const payload = {
      open: !drawerOpen,
      width: drawerWidth,
    };
    dispatch(setDrawerState(payload));
  };

  const drawSousMenus = (sousMenus, key) => {
    return (
      <div style={{ marginLeft: "-10px" }}>
        {sousMenus?.map(
          (menu) =>
            !menu.hide && (
              <React.Fragment key={menu.key}>
                <ListItem
                  key={menu.name}
                  disablePadding
                  onClick={() => onClickMenu(menu.key)}
                  sx={{
                    color: "white",
                    backgroundColor:
                      key === menuIndex && isLeafNode(menu)
                        ? "white"
                        : "transparent",
                    "&:hover": {
                      backgroundColor: "white",
                      ".MuiListItemText-primary": { color: "primary.main" },
                      ".MuiListItemIcon-root": { color: "primary.main" },
                    },
                    borderLeft:
                      menu.key === menuIndex && isLeafNode(menu)
                        ? "4px solid #dda12f"
                        : "4px solid transparent",
                    borderTop:
                      menu.key === menuIndex && isLeafNode(menuIndex)
                        ? "1.5px solid #dda12f"
                        : "1.5px solid transparent",
                    borderBottom:
                      menu.key === menuIndex && isLeafNode(menuIndex)
                        ? "1.5px solid #dda12f"
                        : "1.5px solid transparent",
                  }}
                >
                  <ListItemButton
                    sx={{ justifyContent: "space-between", paddingY: 0 }}
                  >
                    <div>
                      <ListItemText
                        primary={menu.name}
                        sx={{
                          ".MuiListItemText-primary": {
                            color:
                              menuIndex == menu.key ? "#dda12f" : "inherit",
                            ".MuiListItemIcon-root": { color: "primary.main" },
                          },
                        }}
                      />
                    </div>
                    <div>
                      {key === menuIndex && (
                        <ListItemIcon
                          sx={{
                            minWidth: "auto",
                            mr: -2,
                            color: "#dda12f",
                            /*indexMenu === menuIndex &&
                                indexSousMenu === sousMenuIndex
                                  ? "#dda12f"
                                  : "inherit",*/
                            ".MuiListItemIcon-root": {
                              color: "primary.main",
                            },
                          }}
                        >
                          <PlayArrowIcon />
                        </ListItemIcon>
                      )}
                    </div>
                  </ListItemButton>
                </ListItem>

                <SousMenus menu={menu} drawSousMenus={drawSousMenus} />
              </React.Fragment>
            )
        )}
      </div>
    );
  };

  const isLeafNode = (openedMenu) => {
    if (!openedMenu.sousMenus) return true;
    return openedMenu.sousMenus.length === 0;
  };

  function findMenuByKey(menuArray, key) {
    for (let menu of menuArray) {
      if (menu.key === key) {
        return menu;
      }
      if (menu.sousMenus && Array.isArray(menu.sousMenus)) {
        for (let sousMenu of menu.sousMenus) {
          const found = findMenuByKey([sousMenu], key);
          if (found) {
            return found;
          }
        }
      }
    }
    return null;
  }

  const onClickMenu = (key) => {
    let menuList = [...menus];

    menuList.forEach((menu) => {
      if (!key.includes(menu.key)) {
        menu.collapse = false;
      }
    });
    const menu = findMenuByKey(menuList, key);
    if (!menu) return;
    menu.collapse = !menu.collapse;
    setMenus(menuList);
    if (isLeafNode(menu)) {
      console.log("menu.naviage", menu.navigate);
      if (menu.navigate) window.open(menu.navigate, "_blank");

      setMenuIndex(key);
      if (menu.to) {
        navigate(menu.to);
      }
    }
  };

  const drawer = (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Scrollbar style={{ backgroundColor: "#25384a", height: "100%" }}>
        <div
          style={{
            height: "100%",
            padding: "16px 0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 2,
            }}
          >
            {drawerOpen && (
              <IconButton
                aria-label="close"
                onClick={handleDrawerToggle}
                sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
              >
                <KeyboardBackspaceIcon />
              </IconButton>
            )}
            <Box sx={{ marginTop: 2 }}>
              <Avatar
                alt="Profil Image"
                src={profilImage}
                sx={{ width: 80, height: 80 }}
              />
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  color: "white",
                  marginTop: 1,
                }}
              >
                {username}
              </Typography>

              {hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]) && (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    marginTop: 1,
                  }}
                >
                  MEAD
                </Typography>
              )}
              {hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]) && (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    marginTop: 1,
                  }}
                >
                  Compagnie aérienne
                </Typography>
              )}
              {hasAnyRole(["ROLE_VUPORTUARIA_ADMIN"]) && (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    marginTop: 1,
                  }}
                >
                  Administrateur
                </Typography>
              )}
              {hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]) && (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    marginTop: 1,
                  }}
                >
                  Opérateur de manutention
                </Typography>
              )}
              {hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) && (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    marginTop: 1,
                  }}
                >
                  Freight Forwarder
                </Typography>
              )}
            </Box>
          </Box>
          <List
            sx={{
              marginTop: 0.5,
            }}
          >
            {menus.map(
              (menu, index) =>
                menu.hidden !== true &&
                !menu.hide && (
                  <React.Fragment key={menu.name}>
                    <ListItem
                      disablePadding
                      onClick={() => onClickMenu(menu.key)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor:
                          isLeafNode(menu) && index === menuIndex
                            ? "white"
                            : "transparent",
                        ".MuiListItemText-primary": {
                          color:
                            isLeafNode(menu) && index === menuIndex
                              ? "primary.main"
                              : "inherit",
                          fontWeight: index === menuIndex ? 700 : 400,
                        },
                        zIndex:
                          isLeafNode(menu) && index === menuIndex
                            ? 100
                            : "auto",
                        borderLeft:
                          isLeafNode(menu) && index === menuIndex
                            ? "4px solid #dda12f"
                            : "4px solid transparent",
                        borderTop:
                          isLeafNode(menu) && index === menuIndex
                            ? "1.5px solid #dda12f"
                            : "1.5px solid transparent",
                        borderBottom:
                          isLeafNode(menu) && index === menuIndex
                            ? "1.5px solid #dda12f"
                            : "1.5px solid transparent",
                        "&:hover": {
                          backgroundColor: "white",
                          ".MuiListItemText-primary": { color: "primary.main" },
                          ".MuiListItemIcon-root": { color: "primary.main" },
                        },
                      }}
                    >
                      <ListItemButton
                        sx={{
                          paddingY: 0,
                          ml: -1.5,
                          "&:hover .expandItem": {
                            color: "primary.main",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color:
                              index === menuIndex && menu.sousMenus.length === 0
                                ? "primary.main"
                                : "white",
                            "&:hover": { color: "primary.main" },
                          }}
                        >
                          {React.cloneElement(menu.icon, {
                            color:
                              index === menuIndex &&
                                sousMenuIndex === 0 &&
                                menu.sousMenus.length === 0
                                ? "primary.main"
                                : undefined,
                          })}
                        </ListItemIcon>
                        <ListItemText
                          primary={menu.drawerName}
                          primaryTypographyProps={{
                            fontSize: "16px",
                          }}
                          sx={{
                            color: index === menuIndex ? "white" : "white",
                            ".MuiTypography-root": {
                              fontWeight: 400,
                            },
                            "& .MuiListItemText-primary": {
                              marginLeft: "-16px",
                              fontWeight:
                                index === menuIndex ||
                                  (menu.sousMenus.length > 0 &&
                                    menuIndex === index)
                                  ? "700"
                                  : "400",
                            },
                          }}
                        />
                        {menu.sousMenus.length === 0 &&
                          menu.key === menuIndex && (
                            <ListItemIcon
                              sx={{
                                minWidth: "auto",
                                mr: -2,
                                color: "#dda12f",
                              }}
                            >
                              <PlayArrowIcon />
                            </ListItemIcon>
                          )}
                        {menu.sousMenus.length > 0 && (
                          <Box
                            sx={{
                              ml: "auto",
                              display: "flex",
                            }}
                          >
                            {menu.collapse ? (
                              <ExpandLess
                                className="expandItem"
                                sx={{
                                  color: "white",
                                  "&:hover": {
                                    color: "primary.main",
                                  },
                                }}
                              />
                            ) : (
                              <ExpandMore
                                className="expandItem"
                                sx={{
                                  color: "white",
                                  "&:hover": {
                                    color: "primary.main",
                                  },
                                }}
                              />
                            )}
                          </Box>
                        )}
                      </ListItemButton>
                    </ListItem>
                    <SousMenus menu={menu} drawSousMenus={drawSousMenus} />
                  </React.Fragment>
                )
            )}
          </List>
        </div>
      </Scrollbar>
      <div
        style={{
          backgroundColor: "#25384a",
          padding: "16px",
          textAlign: "center",
          marginTop: "auto",
        }}
      >
        <img
          alt="Logo portnet"
          src={logoPortnet}
          style={{ height: 40, marginBottom: -10 }}
        />
      </div>
    </div>
  );

  const facturePaths = [
    "/Factures/gestion-factures",
    "/Factures/consultation-factures",
    "/Factures/nouvelle-demande-dgsn",
    "/Factures/consultation-demande-dgsn",
    "/Factures/NouvelleDemandeFacture/FacturesMarsaMaroc",
    "/Factures/GestionFactures",
    "/Factures/ConsultationFactures",
  ];

  const isFacturePath = facturePaths.includes(location.pathname);
  const isSuspended = localStorage.getItem("suspend") === "true";
  const isInvalidSubscription = localStorage.getItem("valide") === "false";

  const renderForfaitRestriction = (message) => (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
      }}
    >
      <Typography variant="h6" align="center" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );

  const renderForfaitRestrictionImage = (alt, src) => (
    <Box sx={{ marginLeft: 5 }}>
      <Box sx={{ marginLeft: 5 }}>
        <img alt={alt} src={src} />
      </Box>
    </Box>
  );

  const container =
    windowe !== undefined ? () => windowe().document.body : undefined;
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", alignItems: "stretch" }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ ...appBarStyles }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleMobileDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {!drawerOpen && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { xs: "none", sm: "inline-flex" } }}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {findIconByKey(flattenMenus(listMenus()), location.pathname)}
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ marginLeft: 1, fontWeight: "bold" }}
              >
                {findMenuByKey(listMenus(), menuIndex)?.headerTitle}
              </Typography>
            </Box>
            {true == true && (
              <Typography variant="caption" sx={{ color: "textSecondary" }}>
                {breadcrumb}
              </Typography>
            )}
          </Box>

          <ClickAwayListener onClickAway={handleClickAway}>
            <Box sx={{ position: "relative" }}>
              <IconButton onClick={handleUserIconClick} color="inherit">
                <PersonIcon />
              </IconButton>
              {openUserMenu && (
                <Box sx={userMenuStyles}>
                  <MenuList sx={{ padding: "4px 0", zIndex: 9999 }}>
                    <MenuItem
                      onClick={handlePasswordChange}
                      sx={menuListStyles}
                    >
                      Modifier le mot de passe
                    </MenuItem>
                    <MenuItem onClick={handleResetClick} sx={menuListStyles}>
                      Réinitialiser MFA
                    </MenuItem>
                    <MenuItem onClick={handleLogoutClick} sx={menuListStyles}>
                      Se déconnecter
                    </MenuItem>
                  </MenuList>
                </Box>
              )}
            </Box>
          </ClickAwayListener>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: {
            sm: mobileOpen ? drawerWidth : drawerOpen ? drawerWidth : 0,
          },
          transition: "margin 0.22s ease, width 0.22s ease",
          flexShrink: { sm: 0 },
          alignSelf: "stretch",
          minHeight: "100vh",
        }}
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleMobileDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderColor: "#dda12f",
              borderWidth: "1.5px",
            },
          }}
        >
          <div style={{ overflowY: "auto", height: "100%" }}>{drawer}</div>
        </Drawer>
        <Drawer
          variant="persistent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderColor: "#dda12f",
              borderWidth: "1.5px",
              color: "text.white",
            },
          }}
          open={drawerOpen}
        >
          {drawerOpen && (
            <IconButton
              aria-label="close"
              onClick={handleDrawerToggle}
              sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
          )}
          {drawer}
        </Drawer>
      </Box>
      <Box component="main" sx={mainContentStyles}>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            width: "100%",
          }}
        >
          {!isSuspended && !isInvalidSubscription && props.content}
          {isSuspended &&
            (isFacturePath
              ? props.content
              : renderForfaitRestrictionImage("suspendu", suspendu))}
          {!isSuspended &&
            isInvalidSubscription &&
            (isFacturePath
              ? props.content
              : renderForfaitRestrictionImage("nonValide", nonValide))}
        </Box>
        <InstitutionalFooter />
      </Box>

      {config.showComponent && <PuiHelpWidgetProvider
        baseURL={config.baseURL}
        tijariaUrl={config.tijariaUrl}
        apiAuthUrl={config.authUrl}
        guideBaseUrl={config.guideBaseUrl}
        token={localStorage.getItem("token")}
        showReclamation={config.showReclamation}
        showGuides={false}
        portailId={3}
        showTijaria={config.showTijaria}
      >
        <PuiHelpWidget />
      </PuiHelpWidgetProvider>}

      <PopupDialogCustomized
        open={openLogoutDialog}
        onClose={handleCloseDialog}
        title="Déconnexion"
        description={"Voulez-vous vraiment vous déconnecter?"}
        primaryButtonLabel="Oui"
        onPrimaryButtonClick={handleConfirmLogout}
        secondaryButtonLabel="Annuler"
        onSecondaryButtonClick={handleCloseDialog}
      />

      <PopupDialogCustomized
        open={openResetDialog}
        onClose={handleCloseDialog}
        title="Réinitialisation MFA"
        description={"Voulez-vous vraiment réinitialiser votre MFA?"}
        primaryButtonLabel="Oui"
        onPrimaryButtonClick={handleConfirmReset}
        secondaryButtonLabel="Annuler"
        onSecondaryButtonClick={handleCloseDialog}
      />

      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

const SousMenus = ({ menu, drawSousMenus, index, indexSousMenu }) => {
  return (
    <>
      {menu.sousMenus?.length !== 0 && (
        <Collapse
          in={menu.collapse}
          timeout="auto"
          unmountOnExit
          sx={{ marginLeft: 4 }}
        >
          <List component="div" disablePadding>
            {drawSousMenus(menu.sousMenus, menu.key)}
          </List>
        </Collapse>
      )}
    </>
  );
};

DrawerMIC.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  windowee: PropTypes.func,
};

export default DrawerMIC;
